import { mergeLeft } from "ramda";

export const loading = mergeLeft({ loading: true, error: null });
export const loaded = mergeLeft({ loading: false, error: null });
export const explicitLoaded = mergeLeft({
  loading: false,
  loaded: true,
  error: null
});
export const explicitLoading = mergeLeft({
  loading: true,
  loaded: false,
  error: null
});
export const error = (error: string) =>
  mergeLeft({ loading: false, error: error });

export interface LoadState {
  loading: boolean;
  error: any;
}

export interface ExplicitLoadState extends LoadState {
  loaded: boolean;
}

export function replaceSpendCategoryRecords(
  originalArray:any[],
  newRecords:any[],
  targetSpendCategory?: string 
) {
  if (!targetSpendCategory) return newRecords;
  
  // Find the index of the first record with the target spend category
  const firstIndex = originalArray?.findIndex(
    record => record?.spendCat2Id === targetSpendCategory
  );

  if (firstIndex === -1) {
    // If no records found, just append new ones
    //@ts-ignore
    return [...originalArray, ...newRecords];
  }

  // Remove all records with the target spend category
  const filteredArray = originalArray?.filter(
    record => record?.spendCat2Id !== targetSpendCategory
  );

  // Insert new records at the position of the first matching record
  filteredArray?.splice(firstIndex, 0, ...newRecords);

  return filteredArray;
}
